import styled, { css } from 'styled-components';

/**
 * Page-local tokens for the «student control center». Everything shared
 * with GroupDetail (HeaderActions, PrimaryActionButton, Tag, SmallTable,
 * the Form* primitives etc.) lives in
 * `src/components/pages/_detailShared/detail.styled.ts` and is
 * re-exported below so the dozen-plus existing `import * as L from
 * '../StudentDetail.styled'` consumers don't churn.
 *
 * What stays here: the agreement-card composition (header/body/toggle
 * primitives) — these are tightly coupled to per-student layout and
 * have no obvious group analogue.
 */

export * from '../_detailShared/detail.styled';

export const AgreementCardWrap = styled.div<{ terminated?: boolean }>`
  background: #fff;
  border: 1px solid ${({ terminated }) => (terminated ? '#fee2e2' : '#e2e8f0')};
  border-radius: 10px;
  padding: 0;
  margin-bottom: 12px;
  overflow: hidden;
  ${({ terminated }) =>
    terminated &&
    css`
      background: #fffafa;
    `}
`;

export const AgreementHeader = styled.div<{ open: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: ${({ open }) => (open ? '#f8fafc' : 'transparent')};
  border-bottom: 1px solid ${({ open }) => (open ? '#e2e8f0' : 'transparent')};
  transition: background 0.12s;

  &:hover {
    background: #f8fafc;
  }
`;

/**
 * The clickable «expand/collapse» area inside `AgreementHeader`. Lives
 * alongside `HeaderActions` (not around it), so the action buttons aren't
 * nested inside a button — HTML doesn't allow that and React DOM warns.
 */
export const AgreementToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  border: 0;
  background: transparent;
  padding: 12px 16px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
`;

export const Chevron = styled.span<{ open: boolean }>`
  display: inline-block;
  font-size: 11px;
  color: #64748b;
  width: 12px;
  transition: transform 0.15s;
  transform: rotate(${({ open }) => (open ? '90deg' : '0deg')});
`;

export const AgreementTitleLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
`;

export const AgreementMeta = styled.div`
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
`;

export const AgreementBody = styled.div`
  padding: 16px;
`;
